// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"5862c0a6","277":"9cebf589","339":"a406b2ef","453":"2869e761","476":"28980058","913":"70121bcf","943":"36eadf5b"}[chunkId] + ".chunk.js";
};